<template>
  <div>
    <v-toolbar
      dense
      class="tree-toolbar mb-1 sites"
      :class="isClicked ? 'clicked' : ''"
      :elevation="3"
    >
      <!-- Left arrow icon -->
      <v-btn
        v-if="showArrow"
        icon
        @click.stop="toggleChildren"
      >
        <v-icon
          large
          color="primary"
        >
          {{ iconArrow }}
        </v-icon>
      </v-btn>
      <!-- Left arrow icon -->
      <span class="siteTree-title">
        {{ node.name }}
      </span>
      <v-spacer />
    </v-toolbar>
    <div
      v-if="showChildren && !loading"
      class="children-container"
    >
      <div
        v-for="(probe, index) in probes"
        :key="`${index}-${probe.id}-${node.clicked}-${parentNode.clicked}`"
        @click.stop="clickItem(probe, node)"
      >
        <ContainerProbeList
          :id="probe.id"
          :node="probe"
          :parentNode="node"
          :showArrow="false"
          v-on="$listeners"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapGetters } from 'vuex';

export default {
    name: 'ContainerProbeList',
    components: {
    },
    mixins: [
    ],
    props: {
        id: {
            type: String,
            default: '',
        },
        active: {
            type: Boolean,
            default: false,
        },
        showArrow: {
            type: Boolean,
            default: true,
        },
        node: {
            type: Object,
            default: () => {},
        },
        parentNode: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            loadingReport: false,
            legionellaRiskAssessments: [],
            showChildren: false,
            probes: [],
            selectedProbId: '',
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'site',
        ]),
        iconArrow() {
            return this.showChildren ? 'mdi-menu-down' : 'mdi-menu-right';
        },
        isClicked() {
            return this.node.clicked && this.parentNode.clicked && this.node.type === 'probe';
        },
    },

    methods: {
        toggleChildren() {
            if (!this.showChildren) {
                // only loadProbes if toolbar was not open
                this.loadProbes();
            }
            this.showChildren = !this.showChildren;
        },
        clickItem(item, node) {
            this.probes = this.probes.map(n => ({
                ...n,
                clicked: n.id === item.id,
            }));
            this.$emit('sendData', { probeId: item.id, controllerId: node.id });
            this.$emit('updateParentClick', this.parentNode.id);
        },
        async loadProbes() {
            const { data } = await this.$rq.getAvaliableProbes(this.site.id, this.node.id);
            this.probes = data.probes.map(probe => ({ ...probe, type: 'probe' }));
        },
    },
};
</script>

<style lang="scss" scoped>
  .tree-toolbar {
    &.theme--light {
      .v-toolbar__content {
        .v-toolbar__items {
          .v-icon {
            color: #fff;
          }
        }
      }
    }
  }
  .v-list-item::v-deep {
    .v-icon {
      margin-right: 8px;
    }
  }
  .children-container {
    margin-left: 20px;
  }
  .clicked {
    border: 2px solid #26384B;
  }
</style>
